/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Sign_Out_PromptInputs */

const en_users_sign_out_prompt = /** @type {(inputs: Users_Sign_Out_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client access and group changes won't apply until this user signs in again.`)
};

const pt_br2_users_sign_out_prompt = /** @type {(inputs: Users_Sign_Out_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações no acesso a clientes ou nos grupos só terão efeito no próximo login deste usuário.`)
};

/**
* | output |
* | --- |
* | "Client access and group changes won't apply until this user signs in again." |
*
* @param {Users_Sign_Out_PromptInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_sign_out_prompt = /** @type {((inputs?: Users_Sign_Out_PromptInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Sign_Out_PromptInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_sign_out_prompt(inputs)
	return pt_br2_users_sign_out_prompt(inputs)
});